"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[852],{

/***/ 8370:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Yw": function() { return /* binding */ MobileField; },
/* harmony export */   "dg": function() { return /* binding */ VerifyOtpField; },
/* harmony export */   "iF": function() { return /* binding */ FirstNameField; },
/* harmony export */   "jn": function() { return /* binding */ RFFFieldWrapper; },
/* harmony export */   "s8": function() { return /* binding */ EmailField; }
/* harmony export */ });
/* unused harmony exports MessageIcon, BeforeWrapper, BeforeIcon, BeforeEmail */
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(97939);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(70111);
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(89799);
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(78645);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(74512);
/* harmony import */ var _lendi_ui_color__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(62792);
/* harmony import */ var _lendi_ui_field__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(136);
/* harmony import */ var _lendi_ui_icon__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(81114);
/* harmony import */ var _lendi_ui_icon__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(33540);
/* harmony import */ var _lendi_ui_icon__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(5924);
/* harmony import */ var _lendi_ui_icon__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(79007);
/* harmony import */ var _lendi_ui_spacing__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(84209);
/* harmony import */ var _lendi_ui_text_input__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(99673);
/* harmony import */ var _lendi_ui_typography__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(56158);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(32735);
/* harmony import */ var react_final_form__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(75514);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(90471);
/* harmony import */ var _lendi_ui_commons_colours__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(56116);




function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  ",
        "\n  ",
        "\n  text-align: center;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  white-space: nowrap;\n  ",
        "\n  ",
        "\n    display: flex;\n  align-items: center;\n  box-sizing: border-box;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}











var PersonIcon = function() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(BeforeWrapper, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_lendi_ui_icon__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
            color: (0,_lendi_ui_commons_colours__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .ZP)("fill", "accent"),
            width: "24px",
            height: "24px"
        })
    });
};
var PhoneIcon = function() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(BeforeWrapper, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_lendi_ui_icon__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
                color: (0,_lendi_ui_commons_colours__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .ZP)("fill", "accent"),
                width: "24px",
                height: "24px"
            }),
            " ",
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
                children: "+61"
            })
        ]
    });
};
var MessageIcon = function() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(BeforeWrapper, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_lendi_ui_icon__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z, {
            color: (0,_lendi_ui_commons_colours__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .ZP)("fill", "accent"),
            width: "24px",
            height: "24px"
        })
    });
};
var FirstNameField = function(param) {
    var labelText = param.labelText, autoFocus = param.autoFocus, _value = param.value, value = _value === void 0 ? "" : _value;
    var ref = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)(react__WEBPACK_IMPORTED_MODULE_7__.useState(value), 2), fieldValue = ref[0], setFieldValue = ref[1];
    // test case is not happy with React.ChangeEvent<HTMLInputElement>
    var handleChange = function(e) {
        setFieldValue(e.target.value);
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(RFFFieldWrapper, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(react_final_form__WEBPACK_IMPORTED_MODULE_8__/* .Field */ .gN, {
            name: "firstName",
            type: "text",
            children: function(param) {
                var input = param.input, meta = param.meta;
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_lendi_ui_field__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z)({}, meta), {
                    label: labelText,
                    htmlFor: "firstNameInput",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_lendi_ui_text_input__WEBPACK_IMPORTED_MODULE_5__/* .Input */ .II, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z)({
                        // to pass the UTs
                        crossOrigin: ""
                    }, input), {
                        enterKeyHint: "enter",
                        type: "text",
                        isFullWidth: true,
                        placeholder: "Type your first name here",
                        "aria-label": "first name",
                        size: {
                            mobile: "sm",
                            tablet: "md",
                            desktop: "md"
                        },
                        autoFocus: autoFocus,
                        before: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(PersonIcon, {}),
                        onChange: function(e) {
                            input.onChange(e);
                            handleChange(e);
                        },
                        className: "fs-exclude",
                        value: fieldValue
                    }))
                }));
            }
        })
    });
};
var MobileField = function(param) {
    var autoFocus = param.autoFocus, error = param.error, resetAuthError = param.resetAuthError, labelText = param.labelText;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(RFFFieldWrapper, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(react_final_form__WEBPACK_IMPORTED_MODULE_8__/* .Field */ .gN, {
            name: "phoneNumber",
            type: "tel",
            children: function(param) {
                var input = param.input, meta = param.meta;
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_lendi_ui_field__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z)({}, meta), {
                    label: labelText,
                    htmlFor: "phoneNumberInput",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_lendi_ui_text_input__WEBPACK_IMPORTED_MODULE_5__/* .Input */ .II, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z)({
                        // to pass the UTs
                        crossOrigin: ""
                    }, input), {
                        enterKeyHint: "enter",
                        type: "tel",
                        isFullWidth: true,
                        autoComplete: "tel",
                        autoFocus: autoFocus,
                        size: {
                            mobile: "sm",
                            tablet: "md",
                            desktop: "md"
                        },
                        "aria-label": "phone number",
                        before: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(PhoneIcon, {}),
                        onChange: function(e) {
                            if (error) resetAuthError();
                            input.onChange(e);
                        },
                        className: "fs-exclude"
                    }))
                }));
            }
        })
    });
};
var RFFFieldWrapper = styled_components__WEBPACK_IMPORTED_MODULE_16__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-46e86e4e-0"
})(_templateObject(), (0,_lendi_ui_spacing__WEBPACK_IMPORTED_MODULE_4__.my)("sm"), (0,_lendi_ui_color__WEBPACK_IMPORTED_MODULE_2__.fg)("shade.500"));
// @ts-ignore
var BeforeWrapper = styled_components__WEBPACK_IMPORTED_MODULE_16__/* ["default"].span.withConfig */ .ZP.span.withConfig({
    componentId: "sc-46e86e4e-1"
})(_templateObject1(), (0,_lendi_ui_spacing__WEBPACK_IMPORTED_MODULE_4__.ml)("sm"), (0,_lendi_ui_typography__WEBPACK_IMPORTED_MODULE_6__/* .body */ .d1)({
    size: "lg",
    color: "shade.500"
}));
var BeforeIcon = function() {
    return /*#__PURE__*/ _jsx(BeforeWrapper, {
        children: /*#__PURE__*/ _jsx(Lock, {
            color: getColour("fill", "accent"),
            width: "1.5rem",
            height: "1.5rem"
        })
    });
};
var BeforeEmail = function() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(BeforeWrapper, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_lendi_ui_icon__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z, {
            color: (0,_lendi_ui_commons_colours__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .ZP)("fill", "accent"),
            width: "1.5rem",
            height: "1.5rem"
        })
    });
};
var EmailField = function(param) {
    var error = param.error, resetAuthError = param.resetAuthError, label = param.label;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(RFFFieldWrapper, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(react_final_form__WEBPACK_IMPORTED_MODULE_8__/* .Field */ .gN, {
            name: "email",
            children: function(param) {
                var input = param.input, meta = param.meta;
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_lendi_ui_field__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z)({}, meta), {
                    label: label,
                    htmlFor: "emailInput",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_lendi_ui_text_input__WEBPACK_IMPORTED_MODULE_5__/* .Input */ .II, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z)({
                        // to pass the UTs
                        crossOrigin: ""
                    }, input), {
                        enterKeyHint: "enter",
                        placeholder: "Enter your email address",
                        autoComplete: "email",
                        type: "email",
                        size: "md",
                        isFullWidth: true,
                        before: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(BeforeEmail, {}),
                        onChange: function(e) {
                            if (error && resetAuthError) resetAuthError();
                            input.onChange(e);
                        },
                        className: "fs-exclude"
                    }))
                }));
            }
        })
    });
};
var VerifyOtpField = function(param) {
    var autoFocus = param.autoFocus, error = param.error, resetAuthError = param.resetAuthError, label = param.label;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(RFFFieldWrapper, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(react_final_form__WEBPACK_IMPORTED_MODULE_8__/* .Field */ .gN, {
            name: "code",
            type: "tel",
            children: function(param) {
                var input = param.input, meta = param.meta;
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_lendi_ui_field__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z)({}, meta), {
                    label: label,
                    htmlFor: "verifyCodeInput",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_lendi_ui_text_input__WEBPACK_IMPORTED_MODULE_5__/* .Input */ .II, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z)({
                        // to pass the UTs
                        crossOrigin: "",
                        type: "tel",
                        autoFocus: autoFocus,
                        enterKeyHint: "enter",
                        autoComplete: "one-time-code",
                        size: "md",
                        isFullWidth: true,
                        className: "fs-exclude",
                        placeholder: "Enter 6 digit code",
                        before: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(MessageIcon, {})
                    }, input), {
                        onChange: function(e) {
                            if (error && resetAuthError) resetAuthError();
                            input.onChange(e);
                        }
                    }))
                }));
            }
        })
    });
};


/***/ }),

/***/ 89509:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Gu": function() { return /* binding */ validate; },
  "eO": function() { return /* binding */ validateIntlPhone; },
  "Xe": function() { return /* binding */ validateVerifyCard; }
});

// UNUSED EXPORTS: FIRST_NAME_ERROR, INTL_MOBILE_ERROR, MOBILE_ERROR, validateWithName

;// CONCATENATED MODULE: ./helpers/constants.ts
var OTP_VERIFY_FIELD_LABEL = "Please enter your one-time passcode";
var EMAIL_FIELD_EMPTY_LABEL = "Please enter your email address";
var EMAIL_FIELD_VALIDATION_LABEL = "Please provide a valid email address";

// EXTERNAL MODULE: ../../../node_modules/libphonenumber-js/min/exports/parsePhoneNumberWithError.js + 38 modules
var parsePhoneNumberWithError = __webpack_require__(88309);
// EXTERNAL MODULE: ./helpers/util.ts
var util = __webpack_require__(61414);
// EXTERNAL MODULE: ../../../packages/lala-utils/dist/esm/index.js + 23 modules
var esm = __webpack_require__(82839);
;// CONCATENATED MODULE: ./helpers/validation.ts






var MOBILE_ERROR = "Please provide an Australian mobile phone number";
var FIRST_NAME_ERROR = "Please enter your first name";
var INTL_MOBILE_ERROR = "Please provide a valid mobile phone number";
var FIELD_PATHS = {
    CODE: function() {
        return "code";
    },
    EMAIL: function() {
        return "email";
    },
    FIRST_NAME: function() {
        return "firstName";
    },
    PHONE: function() {
        return "phoneNumber";
    }
};
function validateIntlPhone(values) {
    try {
        var _phoneNumber;
        var phoneNumberParsed = (0,parsePhoneNumberWithError/* parsePhoneNumberWithError */.h)((_phoneNumber = values.phoneNumber) !== null && _phoneNumber !== void 0 ? _phoneNumber : "");
        if (!phoneNumberParsed.isPossible() || !phoneNumberParsed.isValid()) {
            return {
                phoneNumber: INTL_MOBILE_ERROR
            };
        }
    } catch (error) {
        esm/* LalaSentry.logError */.GG.logError("Exception on validating intl. number", {
            error: error
        });
        return {
            phoneNumber: INTL_MOBILE_ERROR
        };
    }
    return {};
}
function validate(values) {
    var errors = {};
    if (!values.phoneNumber || !(0,util/* trimPhoneNumber */.u3)(values.phoneNumber).match(/^0?4\d{8}$/)) {
        errors.phoneNumber = MOBILE_ERROR;
    }
    return errors;
}
function validateWithName(values) {
    var errors = {};
    if (!values[FIELD_PATHS.FIRST_NAME()]) {
        errors[FIELD_PATHS.FIRST_NAME()] = FIRST_NAME_ERROR;
    }
    var phoneErrors = validate(values);
    return _object_spread_props(_object_spread({}, phoneErrors), {
        errors: errors
    });
}
var validateVerifyCard = function(newCustomer, values) {
    var errors = {};
    if (!values.code || values.code.length !== 6) {
        errors.code = OTP_VERIFY_FIELD_LABEL;
    }
    if (newCustomer && !values.email) {
        errors.email = EMAIL_FIELD_EMPTY_LABEL;
    } else if (newCustomer && values.email && !String(values.email).toLowerCase().match(/^((?!.*#)([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/)) {
        errors.email = EMAIL_FIELD_VALIDATION_LABEL;
    }
    return errors;
};


/***/ }),

/***/ 76417:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "zG": function() { return /* reexport */ LinkableError; },
  "jM": function() { return /* reexport */ useLinkableCustomerHook; },
  "qM": function() { return /* reexport */ useTranslate; }
});

// EXTERNAL MODULE: ../../../node_modules/react/index.js
var react = __webpack_require__(32735);
// EXTERNAL MODULE: ../../../node_modules/html-react-parser/index.mjs
var html_react_parser = __webpack_require__(82786);
// EXTERNAL MODULE: ./context/index.ts + 4 modules
var context = __webpack_require__(37829);
;// CONCATENATED MODULE: ./hooks/useTranslate.ts



var useTranslate = function(translationKeys) {
    var brandedTranslations = (0,react.useContext)(context/* TranslationContext */.OB);
    if (!brandedTranslations) throw new Error("@lendi/lala-customer-app: No translations loaded.");
    var translationsToReturn = new Array(translationKeys.length);
    translationKeys.forEach(function(key, index) {
        var translation = brandedTranslations[key];
        if (typeof translation === "string") {
            translationsToReturn[index] = translation;
        } else {
            translationsToReturn[index] = (translation === null || translation === void 0 ? void 0 : translation.requireParse) ? (0,html_react_parser/* default */.ZP)(translation.text) : translation === null || translation === void 0 ? void 0 : translation.text;
        }
    });
    return translationsToReturn;
};

// EXTERNAL MODULE: ../../../node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(44229);
// EXTERNAL MODULE: ../../../node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(92712);
// EXTERNAL MODULE: ../../../packages/lala-react/dist/esm/index.js + 318 modules
var esm = __webpack_require__(25980);
// EXTERNAL MODULE: ./api/customer.ts
var customer = __webpack_require__(81878);
// EXTERNAL MODULE: ../../../packages/lala-utils/dist/esm/index.js + 23 modules
var dist_esm = __webpack_require__(82839);
;// CONCATENATED MODULE: ./hooks/useLinkableCustomerHook.ts






var LinkableError;
(function(LinkableError) {
    LinkableError["PERMISSION_DENIED"] = "PERMISSION_DENIED";
    LinkableError["SERVER_ERROR"] = "SERVER_ERROR";
})(LinkableError || (LinkableError = {}));
var useLinkableCustomerHook = function() {
    var session = (0,esm/* useSession */.kP)();
    var status = session.status;
    var ref = (0,react.useState)(""), mobileNumber = ref[0], setMobileNumber = ref[1];
    var ref1 = (0,react.useState)(undefined), apiError = ref1[0], setApiError = ref1[1];
    (0,react.useEffect)(function() {
        dist_esm/* LalaSentry.logInfo */.GG.logInfo("Status changed in useLinkableCustomerHook", {
            status: status
        });
        var callLinkedCustomerFn = function() {
            var _ref = (0,_async_to_generator/* default */.Z)(function() {
                var data, mobileNumber, err;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            _state.trys.push([
                                0,
                                2,
                                ,
                                3
                            ]);
                            return [
                                4,
                                (0,customer/* getLinkedCustomerMobile */.LC)(session)
                            ];
                        case 1:
                            data = _state.sent().data;
                            mobileNumber = data.data.mobileNumber;
                            setMobileNumber(mobileNumber);
                            return [
                                3,
                                3
                            ];
                        case 2:
                            err = _state.sent();
                            if (err.message.indexOf("403") > -1) {
                                setApiError(LinkableError.PERMISSION_DENIED);
                            } else {
                                setApiError(LinkableError.SERVER_ERROR);
                            }
                            return [
                                3,
                                3
                            ];
                        case 3:
                            return [
                                2
                            ];
                    }
                });
            });
            return function callLinkedCustomerFn() {
                return _ref.apply(this, arguments);
            };
        }();
        (0,_async_to_generator/* default */.Z)(function() {
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (!(status === esm/* Status.Authenticated */.qb.Authenticated)) return [
                            3,
                            2
                        ];
                        return [
                            4,
                            callLinkedCustomerFn()
                        ];
                    case 1:
                        _state.sent();
                        _state.label = 2;
                    case 2:
                        return [
                            2
                        ];
                }
            });
        })();
    }, [
        status
    ]);
    return {
        mobileNumber: mobileNumber,
        apiError: apiError
    };
};

;// CONCATENATED MODULE: ./hooks/index.ts




/***/ }),

/***/ 34526:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "L": function() { return /* binding */ AuthenticationFlowLayout; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(89799);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(74512);
/* harmony import */ var _lendi_ui_scripts__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(75793);
/* harmony import */ var _lendi_ui_grid__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(63518);
/* harmony import */ var _lendi_lala_utils__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(82839);
/* harmony import */ var _lendi_navbar__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(62641);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(46582);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(32735);
/* harmony import */ var _hooks__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(76417);
/* harmony import */ var _index_style__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(94022);
/* harmony import */ var _lendi_lala_react__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(25980);











var AuthenticationFlowLayout = function(param) {
    var children = param.children, title = param.title, _alignment = param.alignment, alignment = _alignment === void 0 ? "center" : _alignment, showButtons = param.showButtons;
    var ref = (0,_lendi_lala_react__WEBPACK_IMPORTED_MODULE_8__/* .useSession */ .kP)(), brand = ref.brand, logout = ref.logout;
    var ref1 = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)((0,_hooks__WEBPACK_IMPORTED_MODULE_6__/* .useTranslate */ .qM)([
        "SITE_NAME"
    ]), 1), siteName = ref1[0];
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)((next_head__WEBPACK_IMPORTED_MODULE_4___default()), {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("title", {
                        children: [
                            title || "Sign in",
                            " - ",
                            siteName
                        ]
                    }),
                    brand === _lendi_lala_react__WEBPACK_IMPORTED_MODULE_8__/* .Brand.Lendi */ .H2.Lendi ? _lendi_ui_scripts__WEBPACK_IMPORTED_MODULE_1__/* .LENDI_IS_SCRIPTS */ .W["production"] : _lendi_ui_scripts__WEBPACK_IMPORTED_MODULE_1__/* .AUSSIE_IS_SCRIPTS */ .K["production"]
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_index_style__WEBPACK_IMPORTED_MODULE_7__/* .Root */ .fC, {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_lendi_navbar__WEBPACK_IMPORTED_MODULE_10__/* .SimpleNavbar */ .HE, {
                        onLogout: logout,
                        homeURL: "/",
                        showContinueAction: false,
                        showTalkToExpertCta: !!showButtons,
                        showBookanAppointmentCta: !!showButtons,
                        onException: function(error) {
                            return _lendi_lala_utils__WEBPACK_IMPORTED_MODULE_3__/* .LalaSentry.logToSentry */ .GG.logToSentry("Navbar exception: ".concat(error));
                        }
                    }),
                    alignment === "center" ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_index_style__WEBPACK_IMPORTED_MODULE_7__/* .StyledContainer */ .PQ, {
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_lendi_ui_grid__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP, {
                            halign: "center",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_lendi_ui_grid__WEBPACK_IMPORTED_MODULE_2__/* ["default"].Unit */ .ZP.Unit, {
                                size: {
                                    xs: 1,
                                    sm: 2 / 3,
                                    md: 3 / 4,
                                    lg: 3 / 5,
                                    xl: 1 / 2
                                },
                                children: children
                            })
                        })
                    }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_index_style__WEBPACK_IMPORTED_MODULE_7__/* .GridWrapper */ .zc, {
                        children: children
                    })
                ]
            })
        ]
    });
};


/***/ }),

/***/ 94022:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "PQ": function() { return /* binding */ StyledContainer; },
/* harmony export */   "fC": function() { return /* binding */ Root; },
/* harmony export */   "zc": function() { return /* binding */ GridWrapper; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(78645);
/* harmony import */ var _lendi_ui_color__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(62792);
/* harmony import */ var _lendi_ui_spacing__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(84209);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(90471);
/* harmony import */ var _lendi_ui_container__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(58905);
/* harmony import */ var _lendi_ui_breakpoint__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(23783);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  ",
        "\n  overflow: hidden;\n  min-height: 100vh;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  text-rendering: optimizeLegibility;\n  && input {\n    font-size: max(14px, 1rem);\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    ",
        "\n  "
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    ",
        ";\n  "
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  ",
        ";\n  ",
        "\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}





var Root = styled_components__WEBPACK_IMPORTED_MODULE_5__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-c0c9611-0"
})(_templateObject(), (0,_lendi_ui_color__WEBPACK_IMPORTED_MODULE_1__.bg)("shade.25"));
// @ts-ignore
var GridWrapper = (0,styled_components__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .ZP)(_lendi_ui_container__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z).withConfig({
    componentId: "sc-c0c9611-1"
})(_templateObject2(), (0,_lendi_ui_spacing__WEBPACK_IMPORTED_MODULE_2__.my)("sm"), (0,_lendi_ui_breakpoint__WEBPACK_IMPORTED_MODULE_4__/* .gte */ .eg)("desktop")(_templateObject1(), (0,_lendi_ui_spacing__WEBPACK_IMPORTED_MODULE_2__.my)("xxl")));
// @ts-ignore
var StyledContainer = (0,styled_components__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .ZP)(_lendi_ui_container__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z).withConfig({
    componentId: "sc-c0c9611-2"
})(_templateObject4(), (0,_lendi_ui_spacing__WEBPACK_IMPORTED_MODULE_2__.mt)("xxxs"), (0,_lendi_ui_breakpoint__WEBPACK_IMPORTED_MODULE_4__/* .gte */ .eg)("tablet")(_templateObject3(), (0,_lendi_ui_spacing__WEBPACK_IMPORTED_MODULE_2__.mt)("sm")));


/***/ })

}]);